import {
  faCheckCircle,
  faCircleQuestion,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import { calculateCommonCvdValue, CvdKey } from 'src/models/CvdLevel.model';
import { Disease } from 'src/models/Disease.model';
import { Gender } from 'src/models/Gender.model';
import { handleNSI18Next } from 'src/models/Language.model';
import { Session } from 'src/models/Session.model';

enum CvdRankThreshold {
  ABOVE_AVERAGE = 75,
  AVERAGE = 25,
}
interface ICvdRankData {
  icon: IconDefinition;
  iconText: string;
  className: string;
  desc: string;
}

const getCvdRankData = (session: Session, disease: Disease): ICvdRankData => {
  const { handleReportT } = handleNSI18Next();

  const cvdRankValue = calculateCommonCvdValue(session, CvdKey.RANK, disease);

  if (cvdRankValue === undefined) {
    return {
      icon: faCircleQuestion,
      iconText: handleReportT('cvdSection.cvdRankData.ungradable.iconText'),
      className: 'bg-secondary',
      desc: handleReportT('cvdSection.cvdRankData.ungradable.desc'),
    };
  }

  if (session.gender === Gender.UNSPECIFIED) {
    return {
      icon: faCircleQuestion,
      iconText: handleReportT('cvdSection.cvdRankData.sexUnspecified.iconText'),
      className: 'bg-secondary',
      desc: handleReportT('cvdSection.cvdRankData.sexUnspecified.desc'),
    };
  }

  if (cvdRankValue > CvdRankThreshold.ABOVE_AVERAGE) {
    return {
      icon: faCheckCircle,
      iconText: handleReportT('cvdSection.cvdRankData.aboveAverage.iconText'),
      className: 'bg-success',
      desc: handleReportT('cvdSection.cvdRankData.aboveAverage.desc'),
    };
  }

  if (cvdRankValue >= CvdRankThreshold.AVERAGE) {
    return {
      icon: faCheckCircle,
      iconText: handleReportT('cvdSection.cvdRankData.average.iconText'),
      className: 'bg-optain-200',
      desc: handleReportT('cvdSection.cvdRankData.average.desc'),
    };
  }

  return {
    icon: faTriangleExclamation,
    iconText: handleReportT('cvdSection.cvdRankData.belowAverage.iconText'),
    className: 'bg-warning',
    desc: handleReportT('cvdSection.cvdRankData.belowAverage.desc'),
  };
};

export default getCvdRankData;
